import type { MailboxInfo } from "owa-client-types";
import { getApplicationSettings } from "owa-application-settings";

const WORLDWIDE_TENANT_CLOUD_TYPE = "worldwide";

/**
 * Returns true when the FeedbackSdk.tenantCloudType application setting indicates the
 * Worldwide cloud (or is not provided, which is the default). Returns false for sovereign
 * clouds (e.g. Gallatin, BlackForest, USGovGCCHigh, USGovDoD) where in-app feedback
 * is not allowed.
 */
export function isTenantCloudSupportedForFeedback(mailboxInfo: MailboxInfo): boolean {
    const tenantCloudType = getApplicationSettings("FeedbackSdk", mailboxInfo)?.tenantCloudType;
    if (!tenantCloudType) {
        return true;
    }
    return tenantCloudType.toLowerCase() === WORLDWIDE_TENANT_CLOUD_TYPE;
}
